module.exports = __webpack_public_path__ + "img/rectangularTrapezoidHorizontal.f0817ded.svg";